import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { MiddlewareServiceAttributes } from "@albatrosdeveloper/ave-models-package";
const apiUrl = env.API_AVE_INTEGRATOR_URL;
const moduleName = "middleware_service";

@Injectable({
  providedIn: "root",
})
export class SystemServicesService extends AbstractService<
  RouteGroupAttributes,
  MiddlewareServiceAttributes,
  MiddlewareServiceAttributes
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<MiddlewareServiceAttributes>,
    companyId?,
    status?
  ): Observable<IPaginationResult<MiddlewareServiceAttributes>> {

    const query = buildQuery<MiddlewareServiceAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),

      companyId ? andAllWhere('company.id' as keyof MiddlewareServiceAttributes, Ops.eq(companyId)) : noop(),

      status && status.length > 0 ?
        andAllWhere(
          "statusId",
          Ops.in(...status)
        )
        : noop(),

      orderBy(
        options.sort ?? "createdAt",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string = apiUrl + `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<MiddlewareServiceAttributes>>(API_URL);
  }

  updateSS(id: number, data: any) {
    const API_URL = `http://168.197.69.179:2052/api/pm_middleware_ws/put/${id}`
    return this.http.put<any>(API_URL, data)
  }

  sincronize(code: string): Observable<MiddlewareServiceAttributes> {
    const API_URL: string = apiUrl + `api/${moduleName}/sync?codes=${code}`;
    return this.http.get<any>(API_URL); //IRequestResult<MiddlewareServiceAttributes
  }

  getConfiguration() {
    const API_URL = `http://168.197.69.179:2052/api/pm_middleware_url/get/2/`
    return this.http.get<any>(API_URL)
  }
}
